<template>
  <div class="wrapper flex w-full h-full">
    <div class="relative h-full flex-1 p-4 pb-0 box-border">
      <div class="w-full bg-white overflow-auto" style="height: calc(100% - 38px)">
        <div class="relative" style="top: 8%;">
          <div class="text-center">
            <span class="text-20 font-medium text-theme-black-850 leading-22" v-if="settlementType === 3">费用结算</span
            ><!-- 个人 -->
            <span class="text-20 font-medium text-theme-black-850 leading-22" v-else>开通线上结算</span>
          </div>
          <div class="w-full flex justify-center">
            <div class="text-medium text-theme-black-650 text-center leading-22 mt-4 mb-8">
              <template v-if="settlementType === 3">
                <div>
                  <span>个人用户无法使用费用结算，请切换或创建企业后使用</span>
                </div>
                <br />
              </template>
              <div>
                <span><span v-custom="'out_D74'">调研工厂</span>已上线费用结算服务，助您一键结算面对面访问、电话调查、明察暗访的调查员、代理费用。</span>
              </div>
              <br />
              <div v-if="settlementType === 1 || settlementType === 3">
                <div>
                  <span
                    >开通费用结算服务后，您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{accountingRateVal}} </span
                  >
                </div>
                <div>
                  <span
                    >收取费用，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6%
                    的增值税专用发票或普通发票。</span
                  >
                </div>
              </div>
              <div v-else>
                <div>
                  <span
                    >开通费用结算服务后，您可使用线上结算，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的 {{ accountingRate }}%
                    收取费用【具体服务费费率请联</span
                  >
                </div>
                <div>
                  <span
                    >系与客服联系】，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6%
                    的增值税专用发票或普通发票。</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="pb-6 text-center">
            <img src="/assets/img/settlement/protocol-intro.png" alt="" style="width: 738px" />
          </div>
          <div class="text-center">
            <el-button v-if="settlementType === 1" type="warning" @click="customerService">联系客服开通费用结算</el-button>
            <el-button v-if="settlementType === 2" type="primary" @click="openSignPopup">立即签署</el-button>
          </div>
        </div>
      </div>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="my-2" />
    </div>
    <div class="h-full bg-white" style="width: 290px">
      <div class="text-theme-black-850 pt-6 relative">
        <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-medium leading-22">
          客服联系方式
        </header>
        <div class="leading-24 pl-6 pr-4 pb-6">
          <div class="mt-3 mb-2">
            <span class="text-medium text-theme-black-850">如您对费用结算服务感兴趣，或有任何疑问，请微信扫码联系客服</span>
          </div>
          <SettlementCustomer></SettlementCustomer>
        </div>
      </div>
    </div>
    <el-dialog top="30vh" title="客服联系方式" :visible.sync="customerVisible" width="30%">
      <SettlementCustomer></SettlementCustomer>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userSign, wjSettleIsSign } from '@/api/cost-settlement/common'
import GlobalConfig from '@/global/config'
import SignPopup from '@/views/home/cost-settlement/components/SignPopup'
import { createPopup } from '@/assets/js/factory'
import SettlementCustomer from '@/views/home/cost-settlement/components/SettlementCustomer'
import DygcFooter from 'components/dygc-footer-bottom/index'
export default {
  name: 'OpenSign',
  components: { SettlementCustomer, SignPopup, DygcFooter },
  data() {
    return {
      customerVisible: false
    }
  },
  computed: {
    ...mapGetters(['settlementType', 'accountingRate', 'userInfo']),
    accountingRateVal() {
      return this.accountingRate === null || this.accountingRate === 0 ? '6.5%～7.5%【具体服务费费率请与客服联系】' : `${this.accountingRate}%`
    }
  },
  methods: {
    customerService() {
      this.customerVisible = true
    },
    openSignPopup() {
      if (this.userInfo.isAdmin === 1) {
        const vm = createPopup(SignPopup, { accountingRate: this.accountingRate })
        vm.$on('confirm', () => {
          userSign(GlobalConfig.getCompanyId(), this.userInfo.userId).then(res => {
            vm.$emit('close')
            this.$emit('sign')
            this.$confirm('签署成功,请重新进入', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
              center: true
            }).then(() => {
              window.location.reload()
            })
          })
        })
      } else {
        this.$alert('您当前无法签署，请联系企业管理员签约', '签署协议', {
          confirmButtonText: '我知道了'
        })
      }
    }
  }
}
</script>
